import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import {ApplicationInsights, SeverityLevel} from '@microsoft/applicationinsights-web';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        correlationHeaderExcludedDomains: [
            'account.cohedron.nl'
        ]
    }
});
appInsights.loadAppInsights();

export const trackEvent = (name: string, properties?: { [key: string]: any }) => {
    appInsights.trackEvent({name}, properties);
};

export const trackException = (error: Error) => {
    appInsights.trackException({error: error, severityLevel: SeverityLevel.Error});
}

export {reactPlugin, appInsights};
